import { Theme } from './theme'

const lineHeights: Theme['lineHeights'] = {
  normal: 'normal',
  none: '1',
  shorter: '1.25',
  short: '1.375',
  base: '1.5',
  tall: '1.625',
  taller: '2',
}

export default lineHeights
